export const getImageFromStorage = (path: string): string =>
	`${process.env.STORAGE_ENDPOINT}/${path}`;
